import styled from 'styled-components';
import {device} from '../../../../../../utils/device';

export const VrfyPan = styled.div`
  display: flex;
  flex-direction: column;
`;
export const VrfyPanHdr = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Heading = styled.h3`
  font-size: 32px;
  line-height: 40px;
  font-weight: 900;
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  span {
    width: 28px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 10px;
  }
  @media ${device.mobileS} {
    font-size: 22px;
    line-height: 28px;
    span {
      display: none;
    }
  }
`;
export const SmallText = styled.span`
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  color: #4a4a4a;
  cursor: pointer;
`;
export const SubHeading = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #000;
  margin-bottom: 8px;
  span {
    font-weight: 700;
  }
  @media ${device.mobileS} {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  margin-top: 30px;
  @media ${device.mobileS} {
    margin-top: 20px;
  }
`;
export const Info = styled.div`
  background-color: #fff1dd;
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 30px;
  .icon {
    width: 20px;
    flex-shrink: 0;
    margin-right: 10px;
  }
  p {
    font-size: 12px;
    color: #000000;
    font-weight: 700;
  }
  @media ${device.mobileS} {
  }
`;
export const ErrMsg = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #ef4d51;
  margin-top: 16px;
`;
export const BtnVerify = styled.button`
  width: 136px;
  height: 44px;
  background: linear-gradient(93.66deg, #53b2fe 0%, #065af3 100%);
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Lato';
  font-weight: 900;
  font-size: 16px;
  outline: 0;
  border: 0;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
  ${p =>
    p.isDisable &&
    `
        background: #C2C2C2;
        color: #909090;
        pointer-events: none;
        box-shadow: none;
    `}
`;
